(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/skeleton.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/skeleton.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.skeleton = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "  <div id=\"maltipsetMain\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isStartPage : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials["svs-maltipset-skeleton_partial"],depth0,{"name":"svs-maltipset-skeleton_partial","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "";
},"6":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"maltipsetMain\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.feature || (depth0 && depth0.feature) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ft-maltipset-direct-play",{"name":"feature","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['svs-maltipset-skeleton'] = svs.maltipset.templates.skeleton;
})(svs, Handlebars);

 })(window);